export const enum QuestionnaireComponentType {
    SELECT_QUESTION = `questionnaire.select-question`,
    LONG_TEXT_QUESTION = `questionnaire.long-text-question`,
    SHORT_TEXT_QUESTION = `questionnaire.short-text-question`,
    RADIO_QUESTION = `questionnaire.radio-question`,
    MULTIPLE_CHOICE_QUESTION = `questionnaire.multiple-choice-question`
}